import { ChangeDetectionStrategy, Component, computed } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ModalComponent } from "../modal.component";
import { ModalHeaderComponent } from "../modal.header.component";
import { S25ModalModule } from "../../s25-modal/s25.modal.module";

export interface FreshbooksAccountOption {
    name: string;
    accountId: string;
    type: string;
}

export interface ModalFreshbooksAccountData {
    accounts: FreshbooksAccountOption[];

    /** Set when the user saves; callers read this from the same object passed into the modal. */
    chosenAccountId?: string;
}

@Component({
    template: `
        <s25-modal-header [data]="params()" />
        <div class="modal-body">
            <div class="c-margin-bottom--single">
                <span>Please choose the primary Fresbooks account for your Freshbooks integration.</span>
            </div>
            @for (account of accounts(); track account.accountId) {
                <label class="freshbooks-account-option">
                    <input
                        class="s25-input ngAlignInput c-input input-radio"
                        type="radio"
                        name="chosenAccount"
                        [value]="account.accountId"
                        [(ngModel)]="selectedAccountId"
                    />
                    {{ account.name }}
                </label>
            }
        </div>
        <s25-ng-modal-footer [content]="footerTemplate" [bordered]="true" />
        <ng-template #footerTemplate>
            <button type="button" class="aw-button aw-button--primary" [disabled]="!selectedAccountId" (click)="save()">
                Save
            </button>
        </ng-template>
    `,
    styles: `
        .freshbooks-account-option {
            display: block;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ModalHeaderComponent, FormsModule, S25ModalModule],
})
export class ModalFreshbooksAccountComponent extends ModalComponent<ModalFreshbooksAccountData> {
    static readonly size = "md" as const;
    static readonly title = "Freshbooks Account";
    static readonly asDialog = true;

    selectedAccountId = "";

    readonly accounts = computed(() => this.params()?.accounts ?? []);

    save() {
        const accountId = this.selectedAccountId;
        if (!accountId) {
            return;
        }
        const params = this.params();
        if (!params) {
            return;
        }
        params.chosenAccountId = accountId;
        params.closeModal();
    }
}
